import AbstractAPI from '../../common/AbstractAPI';
import { HTTPMethod } from '../../common/Constants';
import SiteConstants from '../../common/SiteConstants/SiteConstants';
import { buildRequestUrl } from '../../common/utils';

class YoutubeChannelValidationRequestAPI extends AbstractAPI {
  static validateChannel(options) {
    const requestOptions = this.buildFetchOptions(HTTPMethod.GET);

    const url = buildRequestUrl(
      SiteConstants.buildInstance().getYoutubeChannelValidationApiRoute(),
      { youtube_channel_id_1: options.youtubeChannelId }
    );

    return this.request(url, requestOptions);
  }
}

export default YoutubeChannelValidationRequestAPI;
